import React from "react";
import { getSelectedValueBasedOnField, isSet } from "../../../Utils/CommonFunctions";
import { extractFieldValue,flattenPathObject, sortByDataList } from "../MarkupFunctions";
import ScmSubFormBody from "./ScmSubFormBody";
import Wrp from "../../../hoc/Wrp/Wrp";

const ScmDatatableField = ({ attributes, elmtParams })=>{
     const {convertAndRenderElement} = elmtParams;
    const {children,dynamicAssignVar,defProps} = elmtParams; //loopData,dataTable,
  
    let {dynamicVar,tagName} = elmtParams;
    const {fieldGroups,nonFieldGroups,subform_data,rateWithShipments,outputResponse} = defProps;
     
    let fieldAndNonFieldGroups = [...fieldGroups,...isSet(nonFieldGroups,[])];
    let {entries,flatmap,sort,sortby} = attributes;
   
    if(isSet(entries,null)===null){ return false;}
    
    let element = null;
    let iterateArrayObject = [];
    let isSubformField = false;
    let extractedValue = null;
    dynamicVar = {
      ...dynamicVar,
      ...outputResponse
    }
  // console.log('dynamicVar',dynamicVar,entries);
    try{
      if(entries.indexOf('.keys()')!==-1){
        const replaceEntries = entries.replace('.keys()','');
        const objectKeys = Object.keys(dynamicVar[replaceEntries]);
        iterateArrayObject = objectKeys;
           
      }else{
        try{
          dynamicVar = {
          ...dynamicVar,
          [entries]:rateWithShipments[entries]
        }
        }catch(e){

        }
        
        
        try{
            dynamicVar = {
              ...dynamicVar,
              [entries]:extractFieldValue(dynamicVar,entries)
            }
        }catch(e){
            // console.log(e);
        }
       
        if(isSet(flatmap,null)!==null){
          dynamicVar = {
            ...dynamicVar,
            [entries]:flattenPathObject(dynamicVar[entries],flatmap)
          }
        }
        
        // Handle fields object - get keys where is_subform_field === true
        extractedValue = dynamicVar[entries];
        if(extractedValue && typeof extractedValue === 'object' && !Array.isArray(extractedValue)){
          // Filter object entries to only include keys where is_subform_field === true
          const filteredEntries = Object.entries(extractedValue)
            .filter(([key, value]) => value && value.is_subform_field === true)
            .map(([key, value]) => ({ ...value, fieldName: key }));
            if(filteredEntries.length > 0){
              isSubformField = true;
              
              // Extract handlers from defProps that SubformTypeForm uses
              const subformHandlers = {
                setSubFormDataAction: defProps.setSubFormDataAction,
                onChangeInputAction: defProps.onChangeInputAction,
                updateFormsInDetailView: defProps.updateFormsInDetailView,
                succMessage: defProps.succMessage,
                failMessage: defProps.failMessage,
                clearSubformValidation: defProps.clearSubformValidation
              };
              
              // Store handlers in dynamicVar so they're accessible in the loop context
              dynamicVar = {
                ...dynamicVar,
                _subformHandlers: subformHandlers
              };
            }
          // if(filteredEntries.length > 0){
          //   extractedValue = filteredEntries;
          // }
        }
     
        // If isSubformField is true, render custom SubForm components
    if(isSubformField && extractedValue){
      // Get parent section name from entries (e.g., "Package" from "Package.fields")
      const parentSectionName = entries.split('.')[0];
      let parentSection = null;
      
      // Try to get parent section from dynamicVar or fieldGroups
      if(dynamicVar[parentSectionName] && dynamicVar[parentSectionName].fields){
        parentSection = dynamicVar[parentSectionName];
      } else {
        // Find from fieldGroups
        const foundSection = fieldGroups.find((section) => 
          section.title.toLowerCase() === parentSectionName.toLowerCase()
        );
        if(foundSection){
          parentSection = foundSection;
        }
      }
      
      if(parentSection){
        // Construct section object with filtered fields
        const filteredFieldsArray = Object.entries(extractedValue)
          .filter(([key, value]) => value && value.is_subform_field === true)
          .map(([key, value]) => value);
        
        const section = {
          ...parentSection,
          type: 'subform',
          data: filteredFieldsArray
        };
        
        // Find subform data
        const subformIndex = isSet(subform_data, []).findIndex(function(subform) {
          return subform.field_group_section_id == section.id;
        });
        
        const sectionSubformData = (subformIndex >= 0) ? subform_data[subformIndex] : {
          field_group_id: "",
          field_group_section_id: section.id,
          field_group_name: "",
          subform_rows: []
        };
        
        const {modType} = defProps;
        const sectionIndex = fieldGroups.findIndex((s) => 
          s.title.toLowerCase() === parentSection.title.toLowerCase()
        );
        
        // Create addSubformRowHandler for Add button
        const addSubformRowHandler = () => {
          const newRow = {
            id: "",
            display_postition: sectionSubformData.subform_rows.length,
            is_selected: false,
            isOpenBox: true,
            subform_column_values: section.data.map((item) => {
              return {
                table_descriptor_id: item.id,
                display_name: item.label?.blocks?.[0]?.text || '',
                selected_value: '',
                selected_value_text: '',
                dpnm: '',
                reminder: '',
                files: '',
                overridden: false,
                currency_code: 'CAD',
                options: item.options || []
              };
            })
          };
          sectionSubformData.subform_rows.push(newRow);
          if (defProps.setSubFormDataAction) {
            defProps.setSubFormDataAction(modType, [...subform_data]);
          }
        };
        // [attributes.var]:{
                //     ...dynamicVar[isSet(attributes?.var,'')],
                //     loopIndex:rowIndex
                // },
        // console.log('attributes',attributes);
        // Create elmtParams with handlers
        // console.log('dynamicVar55555',dynamicVar,attributes);
        const customElmtParams = {
          ...elmtParams,
          dynamicVar: dynamicVar,
          attributes:attributes,
          subformData: subform_data,
          // Pass the loop variable name from datatable (e.g., "pkg")
          loopVariableName: attributes.var || 'pkg',
          // Pass addSubformRowHandler for Add button
          addSubformRowHandler: addSubformRowHandler,
          section: section,
          sectionSubformData: sectionSubformData,
          subformIndex: subformIndex >= 0 ? subformIndex : 0,
          // Pass layout rules related props for layout rules evaluation
          defProps: {
            ...defProps,
            layoutRules: defProps?.layoutRules || {},
            rulesMapping: defProps?.rulesMapping || {},
            layoutObject: defProps?.layoutObject || {},
            fieldGroups: defProps?.fieldGroups || [],
            validationForms: defProps?.validationForms || {},
            actionButton: defProps?.actionButton || {}
          }
        };
        
        return (
          <Wrp>
            <ScmSubFormBody
              subformIndex={subformIndex >= 0 ? subformIndex : 0}
              sectionSubformData={sectionSubformData}
              pageType={'form'}
              modType={modType}
              isWrite={true}
              section={section}
              reminderDisplayText={defProps.reminderDisplayText}
              shouldRenderButton={true}
             
              sectionType={defProps.sectionType || 'Default'}
              updateSubformRow={defProps.updateSubformRow}
              saveAndUpdateSubform={defProps.saveAndUpdateSubform}
              removeSubformDataHandler={defProps.removeSubformDataHandler}
              onChangeInputAction={dynamicVar._subformHandlers?.onChangeInputAction}
              isSelectAll={false}
              selectHandler={defProps.selectHandler}
              children={children}
              elmtParams={customElmtParams}
              subformData={subform_data}
            />
          </Wrp>
        );
      }
    }
   
   
    
        iterateArrayObject = extractedValue;
        
        // console.log('filteredEntries',isSubformField,dynamicVar,entries);
        
        
        
        //  console.log('dynamicVar1111111',iterateArrayObject);
        if(isSet(sort,null)!==null){
          const sorted = sortByDataList([...iterateArrayObject],sort, isSet(dynamicAssignVar[attributes.var],sortby)); 
          iterateArrayObject = sorted;
        }
      }
    }catch(e){
      console.log('edynamicVar',e);
    }
    // console.log('iterateArrayObject',iterateArrayObject);
    try{
        fieldAndNonFieldGroups.map((section)=>{
          if(section.type==='subform'){
            let lookupDataArr = [];
            // console.log('isSet.toLowerCase',isSet(entries,'').toLowerCase());
            if(section.title.toLowerCase()===isSet(entries,'').toLowerCase()){
              subform_data.map((subSec)=>{
                if(subSec.field_group_section_id===section.id){
                  subSec.subform_rows.map((subRows)=>{
                    let fieldRow = {};
                    subRows.subform_column_values.map((subCol)=>{
                     
                      const finding = section.data.find((i=>i.id===subCol.table_descriptor_id));
                      const selectedValue = getSelectedValueBasedOnField({...finding,selectedValue:subCol.selected_value})
                      fieldRow  = {
                        ...fieldRow,
                        [isSet(subCol.display_name,'')]:(selectedValue!=='-None-')?selectedValue:''
                      }
                    })
                    lookupDataArr.push(fieldRow);
                  })
                  
                }
              })
              iterateArrayObject = lookupDataArr;
            }
          }else{
            return section.data.map((field)=>{
            if(field.label.entityMap==null){
                field.label.entityMap = {};
              }
              let selectedValue = null;
              let elementType = field.element;
              // let isDetailView = field.is_present_in_detailview;
              let selectedValueJSON = null;
              let lookupDataArr = [];
              // console.log('fieldd',field);
              //isSet(field.value,'').toLowerCase()===isSet(type,'').toLowerCase() ||
              if( field.label.blocks[0].text.toLowerCase()===isSet(entries,'').toLowerCase()){
              if((elementType==='MultiLookup' || elementType==='Lookup')){
                  try { 
                    selectedValueJSON = (field.selectedValue!=='')?JSON.parse(field.selectedValue):'';
                  }catch(e){

                  }
                  if(elementType==='Lookup' || (Array.isArray(selectedValueJSON)===false) || selectedValueJSON===null || selectedValueJSON===''){
                      if(section.refLookup===true){
                      selectedValue = selectedValueJSON;
                      
                      }else{
                      selectedValue = [];
                      selectedValue.push(selectedValueJSON);
                      } 
                    }else{
                        selectedValue = selectedValueJSON;
                    }
                    isSet(field.stateValue,[]).map((contentData)=>{
                      let fieldRow = {};
                      Object.entries(contentData.data.data).map(([key, val]) => {
                        if(isSet(val.label,'')!==''){
                          fieldRow  = {
                            ...fieldRow,
                            [isSet(val.label,'')]:(isSet(field.required_query,false)===true)?`All ${field.value}`:val.value
                          }
                        }
                      })
                      lookupDataArr.push(fieldRow);
                    });
                    isSet(selectedValue,[]).map((contentData)=>{
                        let fieldRow = {};
                        try{
                          if(elementType==='Lookup'){
                            // console.log('contentData',contentData);
                            fieldRow  = {
                              ...fieldRow,
                              [contentData.id]:contentData.dpnm
                            }
                          }
                        }catch(e){

                        }
                      if(contentData!==null && contentData!==''){
                        contentData.fieldGroups.map((section)=>{
                          section.data.forEach((item)=>{
                              try{
                                fieldRow  = {
                                  ...fieldRow,
                                  [item.label.blocks[0].text]:(isSet(field.required_query,false)===true)?`All ${field.value}`:getSelectedValueBasedOnField(item)
                                }
                              }catch(e){

                              }
                              
                            return item;      
                          })
                          return section;   
                        });
                      }
                      if(Object.entries(fieldRow).length>0){
                        lookupDataArr.push(fieldRow);
                      }
                      return contentData;
                    });
                    try{
                      if(field.element==='MultiLookup' && field.required_query===true){
                        lookupDataArr = lookupDataArr.slice(-1);
                      }
                    }catch(e){

                    }
                    
              }
              iterateArrayObject = lookupDataArr;
              // console.log('iterateArrayObject',iterateArrayObject);
              }
              })
          }
      })
    }catch(e){
      console.log('e',e);
    }
    
    
    // console.log('iterateArrayObject',iterateArrayObject);
    try{
      
      element = iterateArrayObject.map((loopDataItem,index)=>{
        let loopData = loopDataItem;
        // console.log('loopData',loopData);
        // if(!Array.isArray(loopData)){
        //   loopData = {
        //     value:loopDataItem,
        //     index:index
        //   }
        // }
        dynamicVar = {
          ...dynamicVar,
          [attributes.var]:{
            ...loopData,
            loopIndex:index
          }
        }
        // console.log('dynamicVar11',dynamicVar);
        if(children.length===0){
          return React.createElement(tagName, {...attributes});
        }else{
            if(tagName==='scm:datatable'){
              tagName = isSet(attributes.tag,tagName);
              return convertAndRenderElement(children,{...elmtParams,loopData:{
                ...loopData,
                loopIndex:index
              },dynamicVar:dynamicVar});
            }
            // console.log('tagName',tagName);
          return React.createElement(tagName, {...attributes},convertAndRenderElement(children,{...elmtParams,loopData:{
            ...loopData,
            loopIndex:index
          },dynamicVar:dynamicVar}));
        }
      });
      
    }catch(e){
      dynamicVar = {
        ...dynamicVar,
        [attributes.var]:iterateArrayObject
      }
      
      if(children.length===0){
        return React.createElement(tagName, {...attributes});
      }else{
          if(tagName==='scm:datatable'){
            tagName = isSet(attributes.tag,tagName);
            return convertAndRenderElement(children,{...elmtParams,dynamicVar:dynamicVar});
          }
        return React.createElement(tagName, {...attributes}, convertAndRenderElement(children,{...elmtParams,dynamicVar:dynamicVar}));
      }
    }
    return element;
  }


  export default ScmDatatableField;